export default __webpack_public_path__ + "static/media/gridicons_add-outline.27de034a.svg";